// extracted by mini-css-extract-plugin
export var cardHeader = "_g5-0";
export var reorderHandle = "_g5-3";
export var titleArea = "_g5-1";
export var titleAreaWithHandle = "_g5-2";